/** Temporary director enrich payload matching getDirectorApolloProfile shape. */
export const DIRECTOR_APOLLO_TEST_PAYLOAD = {
  customerId: "7f5ebd14-8ae0-4e61-a126-cb2dd720e500",
  directorUuid: "5b591d0a-5fa8-4ab2-bb73-a0f2d28c2e12",
  din: "08020697",
  name: "NAMITA NAIR",
  email: "jordan.blake@northstaranalytics.io",
  apolloPeopleMatchLink:
    "CUSTOMER/apollo/people-match/7f5ebd14-8ae0-4e61-a126-cb2dd720e500/5b591d0a-5fa8-4ab2-bb73-a0f2d28c2e12.json",
  apolloRequestId: "718432950164203900",
  apolloPersonIsFetched: true,
  apolloPerson: {
    person: {
      id: "672c91d4a7be42000184f2c9",
      first_name: "Jordan",
      last_name: "Blake",
      name: "NAMITA NAIR",
      linkedin_url: "http://www.linkedin.com/in/jordan-blake-4a7c21",
      title: "Founder & CEO",
      email_status: "verified",
      photo_url: null,
      headline: "Founder & CEO at Northstar Analytics",
      email: "jordan.blake@northstaranalytics.io",
      organization_id: "61f2d5a8c40b7200019e4f31",
      match_confidence: "high",
      employment_history: [
        {
          id: "672c93a1b8df4e0001f732a1",
          current: true,
          organization_name: "Northstar Analytics",
          start_date: "2016-01-01",
          end_date: null,
          title: "Founder & CEO",
        },
        {
          id: "672c93a1b8df4e0001f732a2",
          current: false,
          organization_name: "BrightForge Labs",
          start_date: "2011-01-01",
          end_date: "2015-01-01",
          title: "Founder & CEO",
        },
        {
          id: "672c93a1b8df4e0001f732a3",
          current: false,
          organization_name: "Redwood Capital Group",
          start_date: "2011-01-01",
          end_date: "2011-01-01",
          title: "Investment & Trading Associate",
        },
      ],
      education: [
        {
          school: "Stanford University",
          degree: "MBA",
          field: "Finance",
          start_date: "2008-09-01",
          end_date: "2010-06-01",
        },
      ],
      state: "California",
      city: "San Francisco",
      country: "United States",
      departments: ["c_suite"],
      seniority: "founder",
      organization: {
        id: "61f2d5a8c40b7200019e4f31",
        name: "Northstar Analytics",
        website_url: "https://www.northstaranalytics.io",
        primary_domain: "northstaranalytics.io",
        short_description:
          "Northstar Analytics combines business data, sales engagement, and automation tools in one platform.",
      },
      contact: {
        sanitized_phone: "+14155550158",
        email: "jordan.blake@northstaranalytics.io",
        phone_numbers: [
          {
            raw_number: "(415) 555-0158",
            sanitized_number: "+14155550158",
            status: "valid_number",
          },
        ],
      },
    },
    waterfall: {
      status: "accepted",
      message:
        "Waterfall enrichment request accepted. Results will be sent to the provided webhook URL.",
    },
    request_id: 718432950164203900,
  },
};
